module.exports = __webpack_public_path__ + "static/media/T10.dd6646ea.jpg";